import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { az as _, t as h, d as t, j as u } from "../../vendor-EQDp64ng.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as p } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as r } from "../BaseIcon/index.js";
import { FieldDescription as b } from "../FieldDescription/index.js";
import { FieldError as j } from "../FieldError/index.js";
import { FieldLabel as F } from "../FieldLabel/index.js";
import { Input as k } from "../Input/index.js";
import '../../assets/index45.css';const $ = "_label_1eksj_1", I = "_decoration_1eksj_5", x = "_clearButton_1eksj_15", z = "_searchIcon_1eksj_25", N = "_searchField_1eksj_34", B = "_fieldControl_1eksj_49", C = "_input_1eksj_60", S = "_horizontal_1eksj_82", W = "_fullWidth_1eksj_100", o = {
  label: $,
  decoration: I,
  clearButton: x,
  searchIcon: z,
  searchField: N,
  fieldControl: B,
  input: C,
  horizontal: S,
  fullWidth: W
}, A = ({
  label: c,
  description: s,
  errorMessage: n,
  fullWidth: i = !1,
  horizontal: d = !1,
  placeholder: m = "Search",
  autoFocus_I_READ_THE_JSDOC: f,
  ...l
}) => /* @__PURE__ */ a(
  _,
  {
    ...p(l),
    autoFocus: f,
    className: t(o.searchField, {
      [o.fullWidth]: i,
      [o.horizontal]: d
    }),
    "data-component": "SearchField",
    children: [
      /* @__PURE__ */ e(F, { className: o.label, children: c }),
      /* @__PURE__ */ a(h, { className: o.fieldControl, children: [
        /* @__PURE__ */ e(
          r,
          {
            icon: "search",
            size: "sm",
            color: "moon",
            className: t(o.decoration, o.searchIcon)
          }
        ),
        /* @__PURE__ */ e(
          k,
          {
            autoComplete: "off",
            placeholder: m,
            className: o.input,
            "aria-label": l["aria-label"],
            onInput: l.onInput,
            value: l.value
          }
        ),
        /* @__PURE__ */ e(u, { className: t(o.decoration, o.clearButton), children: /* @__PURE__ */ e(r, { icon: "close", size: "sm", color: "moon" }) })
      ] }),
      /* @__PURE__ */ e(b, { children: s }),
      /* @__PURE__ */ e(j, { children: n })
    ]
  }
);
export {
  A as SearchField
};
